import { useGetCustomerConfigQuery } from "@/redux/reducer/customers.api";
import { getUser, getUserTenantId, logout } from "@talentech/bff-login";
import { Button, ButtonColors, SplashScreen, TalentechSvgImages } from "@talentech/components";
import { PropsWithChildren } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { customerGate } from "./customerGate";

const CustomerProvider: React.FC<PropsWithChildren<{enabled: boolean }>> = (props) => {
  const tenantId = useSelector(getUserTenantId)
  const user = useSelector(getUser)
  const { data, currentData, isSuccess, isFetching } = useGetCustomerConfigQuery({
    tenantId
  });

  const dispatch = useDispatch();
  const gate = customerGate({ isFetching, isSuccess, data, currentData, enabled: props.enabled });

  if (gate === "loading") {
    return (
      <SplashScreen
        image={TalentechSvgImages.SCIENE_TECHNOLOGY_ROCKET}
        productName="Career Sites"
        title="Loading customer configuration"
        subtitle="Please wait while we load your configuration"
        isFullPage
      />
    );
  }

  if (gate === "customer") {
    return props.children;
  }

  return (
    <SplashScreen
      image={TalentechSvgImages.SHIELDS_PADLOCK_SHIELD}
      productName="Career Sites"
      title="Access Denied"
      subtitle={`This tenant: ${user?.tenantName} - is not allowed to access this application`}
      isFullPage
      customComponent={
        <Button label="Logout" onClick={() => dispatch(logout())} color={ButtonColors.PRIMARY} icon={<i className="fa-sharp fa-sign-out me-2" />} />
      }
    />
  );
};

export default CustomerProvider;
